export default "__VITE_ASSET__BTVmoBZJ__"